export default __webpack_public_path__ + "static/media/everglow-02.6eb41479.png";